export { ProductsComponent } from './lib/feature-products/src/lib/products/products.component';

export { PRODUCTS_ROUTES } from './lib/products.routes';

// La lista de productos del usuario, con su codigo: la usan los parametros de configuracion para
// elegir el producto de una plantilla (HT_ARQ_012), la misma fuente que el selector de producto.
export { ProductsService } from './lib/data-access/src/lib/products.service';
export type { AppSummary } from './lib/domain/src/lib/products.model';

// El producto de la pestaña sigue a la URL que se abre (enlace de otro producto en una pestaña nueva).
export { productoDeLaRutaGuard } from './lib/guard/src/lib/producto-de-la-ruta.guard';
